import { toBoundaryMask } from '../js-segment-annotator-code/js-segment-annotator-helpers';
import { SuperpixelAlgorithmResult } from '../js-segment-annotator-code/superpixel-algorithm-result';

export abstract class AbstractAlgorithmAdapter<Options> {
  abstract readonly name: string;

  constructor(protected image: ImageData) {}

  protected get imageArea() {
    return this.image.width * this.image.height;
  }

  abstract get minRelativeSize(): number;

  abstract get maxRelativeSize(): number;

  computeSuperpixels(relativeSize: number) {
    const options = this.createOptions(relativeSize);
    const result = this.executeAlgorithm(options);
    result.boundaryMask = toBoundaryMask(result);
    return result;
  }

  private createOptions(relativeSize: number) {
    let newOptions = this.defaultOptions();

    for (let i = Math.abs(relativeSize); --i >= 0; ) {
      if (relativeSize > 0) {
        newOptions = this.adjustForBiggerSuperpixels(newOptions);
      } else if (relativeSize < 0) {
        newOptions = this.adjustForSmallerSuperpixels(newOptions);
      }
    }

    return newOptions;
  }

  protected abstract executeAlgorithm(
    options: Options,
  ): SuperpixelAlgorithmResult;

  protected abstract defaultOptions(): Options;

  protected abstract adjustForBiggerSuperpixels(options: Options): Options;

  protected abstract adjustForSmallerSuperpixels(options: Options): Options;
}
